import {createSlice} from "@reduxjs/toolkit";
import { BaseUserSignUp, UserMemberModel } from "../model/ua/UserMemberModel";

interface SignUpState {
  currentStep: number;
  basicInfo: BaseUserSignUp;
  kepcoCustRegs: any[];
  kepcoCustDeleteFiles: any[],
  kepcoCustDataFiles: any[],

  signUpInfo: UserMemberModel;
  signUpComCd: any;
}

const initialBasicInfo: BaseUserSignUp = {
  emksMbrsClCd: undefined,
  mktgJoinAgreYn: undefined,

  emksRe100JoinClCd: undefined,
  emksEntClCd: undefined,

  userId: undefined,
  userPwdEncVal: undefined,
  conFirmPw: undefined,

  bizrNm: undefined,
  comRegNumFi: undefined,
  comRegNumSe: undefined,
  comRegNumTh: undefined,

  coRepNo: undefined,
  repNumFi: undefined,
  repNumSe: undefined,
  repNumTh: undefined,

  bizrAddr: undefined,
  bizrDtlsAddr: undefined,

  tchgrNm: undefined,

  tchgrCplcNo: undefined,
  tchgrCplcFi: undefined,
  tchgrCplcSe: undefined,
  tchgrCplcTh: undefined,

  tchgrEmailAddr: undefined,
  emailPrefix: undefined,
  emailSuffix: undefined,
};

const initialState: SignUpState = {
  currentStep: 1,
  basicInfo: initialBasicInfo,
  kepcoCustRegs: [],
  kepcoCustDeleteFiles: [],
  kepcoCustDataFiles: [],

  signUpInfo: new UserMemberModel,
  signUpComCd: {
    ComUnit: [],
    EmksCustTpClCd: [],
    EmksEntClCd: [],
    EmksEqpKndCd: [],
    EmksIndsCmplxClCd: [],
    EmksMbrsClCd: [],
    EmksPrtclKndCd: [],
    EmksRe100JoinClCd: [],
    EmksRsrcClCd: [],
    MobileNumberPrefix: []
  }
}

const SignUpSlice = createSlice({
  name: 'signUpSlice',
  initialState,
  reducers: {
    setSignUpInfo: (state, action) => {
      state.signUpInfo = action.payload;
    },
    setSignUpComCd: (state, action) => {
      state.signUpComCd = action.payload;
    },
    clearSignUpInfo: (state) => {
      state.signUpInfo = new UserMemberModel;
    },

    goNextStep: (state) => {
      if (state.currentStep) {
        state.currentStep = state.currentStep + 1;
      } else {
        state.currentStep = 1;
      }
    },
    goPrevStep: (state) => {
      if (state.currentStep > 1 && state.currentStep !== 99) {
        state.currentStep = state.currentStep - 1;
      }
    },
    goSuccessStep: (state) => {
      state.basicInfo = { emksMbrsClCd: state.basicInfo.emksMbrsClCd };
      state.kepcoCustRegs = [];
      state.kepcoCustDeleteFiles = [];
      state.kepcoCustDataFiles = [];
      state.currentStep = 99;
    },
    updateBasicInfo: (state, action) => {
      if (!state.basicInfo) {
        state.basicInfo = action.payload;
      } else {
        state.basicInfo = {
          ...state.basicInfo,
          ...action.payload,
        }
      }
    },
    clearBasicInfo: (state) => {
      state.basicInfo = initialBasicInfo;
      state.kepcoCustRegs = [];
      state.kepcoCustDeleteFiles = [];
      state.kepcoCustDataFiles = [];
      state.currentStep = 1;
    },
    updateKepcoCustRegs: (state, action) => {
      const userKepcoDatas = action.payload;
      state.kepcoCustRegs = userKepcoDatas.kepcoCustRegs;
      state.kepcoCustDeleteFiles = userKepcoDatas.deleteFile;
      state.kepcoCustDataFiles = userKepcoDatas.dataFile;
    },
  },
});

export default SignUpSlice.reducer;
export const {
  setSignUpInfo,
  clearSignUpInfo ,
  setSignUpComCd,

  goNextStep,
  goPrevStep,
  goSuccessStep,
  updateBasicInfo,
  clearBasicInfo,
  updateKepcoCustRegs
} = SignUpSlice.actions;